import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./en.json";
import mk from "./mk.json";
import sr from "./sr.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      mk: { translation: mk },
      sr: { translation: sr },
    },
    fallbackLng: "mk",
    supportedLngs: ["en", "mk", "sr"],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // Only honour an explicit saved choice; everyone else defaults to
      // Macedonian (fallbackLng) rather than their browser language.
      order: ["localStorage"],
      lookupLocalStorage: "besthr_lang",
      caches: ["localStorage"],
    },
  });

export default i18n;
